import { Megaphone, RotateCw, Plus } from "lucide-react";
import { Section, money } from "../dc";
import { CAMPAIGNS } from "./data";

const TONE = { Active: "pos", Draft: "neutral", Done: "accent" };

export const CampaignList = ({ onOpen, onNew }) => (
  <Section title="Saved campaigns" sub="Per location. Refresh re-runs the audience rules, so new matches appear and people who have since booked drop off." icon={Megaphone} testid="campaign-list"
    right={<button className="btn btn-primary btn-sm" onClick={onNew} data-testid="campaign-new"><Plus size={14} />New campaign</button>}>
    <div style={{ overflowX: "auto" }}>
      <table className="table" style={{ width: "100%" }}>
        <thead><tr>{["Campaign", "Status", "Audience", "Sent", "Booked ≤14d", "Revenue", "Last refresh", ""].map((h) => <th key={h} style={{ textAlign: "left" }}>{h}</th>)}</tr></thead>
        <tbody>
          {CAMPAIGNS.map((c) => (
            <tr key={c.id} data-testid={`campaign-row-${c.id}`}>
              <td><button style={{ fontWeight: 700, color: "var(--accent-ink)", background: "none", border: 0, padding: 0, cursor: "pointer", textAlign: "left" }} onClick={() => onOpen(c)} data-testid={`campaign-open-${c.id}`}>{c.name}</button></td>
              <td><span className={`badge ${TONE[c.status]}`}>{c.status}</span></td>
              <td className="mono">{c.audience}</td>
              <td className="mono">{c.sent}</td>
              <td className="mono">{c.booked}{c.sent ? <span className="muted"> · {Math.round((c.booked / c.sent) * 100)}%</span> : ""}</td>
              <td className="mono" style={{ fontWeight: 700 }}>{c.revenue ? money(c.revenue) : "—"}</td>
              <td className="muted" style={{ fontSize: 12, whiteSpace: "nowrap" }}>{c.refreshed}</td>
              <td><button className="btn btn-sm" data-testid={`campaign-refresh-${c.id}`}><RotateCw size={12} />Refresh</button></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </Section>
);
